import { render, staticRenderFns } from "./notification-group.vue?vue&type=template&id=5cbd261e&"
import script from "./notification-group.vue?vue&type=script&lang=js&"
export * from "./notification-group.vue?vue&type=script&lang=js&"
import style0 from "./notification-group.vue?vue&type=style&index=0&id=5cbd261e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports